import { FaCheckCircle } from "react-icons/fa";

import { ISolicitacaoAtivacao } from "../../../interfaces";

interface IProps {
    solicitacao: ISolicitacaoAtivacao | null;
    etapaOrdem: number;
}

export default function TabCheckIcon({
    solicitacao,
    etapaOrdem,
}: IProps) {
    const etapa = solicitacao?.etapasSolicitacaoAtivacao.find((e) => e.etapa.ordem === etapaOrdem);
    const etapaConcluida = !!etapa?.concluidaEm

    if (!etapaConcluida) {
        return null;
    }

    return (
        <FaCheckCircle
            color="#00B153"
            size={18}
        />
    )
}
